import axios from 'axios'

const PostingService = {
  async get (params = {}) {
    return axios.get('wo/purchase-order/postings', { params })
  },

  async histories (params = {}) {
    return axios.get('wo/reports/purchase-order/posting-histories', { params })
  },

  async show (id) {
    return axios.get(`wo/purchase-order/postings/${id}`)
  },

  async post (params = {}) {
    return axios.post('wo/purchase-order/postings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`wo/purchase-order/postings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`wo/purchase-order/postings/${data.id}`, { data })
  }
}

export default PostingService
